module.exports = __webpack_public_path__ + "static/media/downLoad.4ead7816.svg";